// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"product-image_imgContainer__Hkn8C","img":"product-image_img__46hsZ","unavailable":"product-image_unavailable__Ql_ZX"};